import { render, staticRenderFns } from "./BalanceAccount.vue?vue&type=template&id=462d1be6&scoped=true"
import script from "./BalanceAccount.vue?vue&type=script&lang=js"
export * from "./BalanceAccount.vue?vue&type=script&lang=js"
import style0 from "./BalanceAccount.vue?vue&type=style&index=0&id=462d1be6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462d1be6",
  null
  
)

export default component.exports